import React from 'react';
import { Route, Switch } from 'react-router';
import PropTypes from 'prop-types';
import NotFound from '../NotFound';
import PaxFormStage from './PaxFormStage';
import GuardianFormStage from './GuardianFormStage';
import PdfPreviewContainer from './containers/PdfPreviewContainer';
import SignDocumentContainer from './containers/SignDocumentContainer';

const LoaLawyerRouter = ({
  allCountries,
  onPaxFormSubmit,
  onGuardianFormSubmit,
  onPrevStage,
  paxData,
  guardianData,
  id,
  paxAdult,
  match,
  client,
  loaLawyer,
  history,
  progressBar,
  disablePaxName,
  disablePaxDate,
  paxDisplayName
}) => (
  <div>
    <Switch>
      <Route
        exact
        path={'/loa-lawyer/:id'}
        render={() => (
          <PaxFormStage
            disablePaxName={disablePaxName}
            disablePaxDate={disablePaxDate}
            data={paxData}
            allCountries={allCountries}
            onSubmit={onPaxFormSubmit}
            id={id}
            progressBar={progressBar}
            paxDisplayName={paxDisplayName}
          />
        )}
      />
      <Route
        exact
        path={'/loa-lawyer/:id/guardian'}
        render={() => (
          <GuardianFormStage
            data={guardianData}
            allCountries={allCountries}
            onSubmit={onGuardianFormSubmit}
            onPrevStage={onPrevStage}
            progressBar={progressBar}
            paxDisplayName={paxDisplayName}
          />
        )}
      />
      <Route
        exact
        path={'/loa-lawyer/:id/preview'}
        render={() => (
          <PdfPreviewContainer
            guardianData={guardianData}
            onPrevStage={onPrevStage}
            paxData={paxData}
            paxAdult={paxAdult}
            match={match}
            history={history}
            loaLawyer={loaLawyer}
            client={client}
            allCountries={allCountries}
            progressBar={progressBar}
            paxDisplayName={paxDisplayName}
          />
        )}
      />
      <Route
        exact
        path={'/loa-lawyer/:id/sign'}
        render={() => (
          <SignDocumentContainer
            match={match}
            history={history}
            progressBar={progressBar}
            paxDisplayName={paxDisplayName}
          />
        )}
      />
      <Route render={() => <NotFound />} />
    </Switch>
  </div>
);

LoaLawyerRouter.propTypes = {
  allCountries: PropTypes.array.isRequired,
  onPaxFormSubmit: PropTypes.func.isRequired,
  onGuardianFormSubmit: PropTypes.func.isRequired,
  onPrevStage: PropTypes.func.isRequired,
  paxData: PropTypes.object.isRequired,
  guardianData: PropTypes.object.isRequired,
  progressBar: PropTypes.element.isRequired,
  disablePaxName: PropTypes.bool.isRequired,
  disablePaxDate: PropTypes.bool.isRequired,
  paxDisplayName: PropTypes.string,
};

export default LoaLawyerRouter;



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/LoaLawyerRouter.js